import { nanoid } from "nanoid"
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { api, superAdminReqConfig } from "../../include/api"
import { ERROR, SUCCESS } from '../../include/constant'
import { useNotification } from '../../Toast/ToastProvider'
import Error from "../add-ons/Error"
import Spinner from "../add-ons/Spinner"
import SuperAdminHeader from "./Header"

const SuperAdminShop = () => {
    const [fetchLoading, setFetchLoading] = useState(true)
    const [shopList, setShopList] = useState([])
    const [searchQuery, setSearchQuery] = useState("")
    const [shopCount, setShopCount] = useState(0)

    const getShops = (afterGet) => {
        setFetchLoading(true)
        api.get('/shop/', superAdminReqConfig()).then(response => {
            if (response.status === 200) {
                setShopList(response.data.data)
                setShopCount(response.data.data.length)
                if (afterGet) afterGet(response.data.data)
            }
        }).catch(error => {
            setShopList([])
            setShopCount(0)
            if (afterGet) afterGet([])
        }).finally(() => setFetchLoading(false))
    }

    useEffect(() => {
        getShops()
    }, [])

    const handleSearch = (event) => {
        setSearchQuery(event.target.value.toLowerCase())
    }

    const filteredShops = shopList.filter(shop => 
        shop.name.toLowerCase().includes(searchQuery) ||
        shop.id.toString().toLowerCase().includes(searchQuery) ||
        shop.phoneNumber.toLowerCase().includes(searchQuery) ||
        shop.emailId.toLowerCase().includes(searchQuery) ||
        shop.status.toLowerCase().includes(searchQuery)
    )

    return <SuperAdminHeader >
        <div className="fixed-top-bar mb-5">
            <div className="container my-3">
                <div className="py-3 d-flex justify-content-between align-items-center gap-1">
                    <h5 className="m-0 fs-3">
    Total Shop List: {shopCount} shops 
    (Active: {shopList.filter(shop => shop.status === 'active').length}, 
    Inactive: {shopList.filter(shop => shop.status === 'inactive').length})
</h5>
                    <input 
                        type="text" 
                        className="form-control w-50" 
                        placeholder="Search by name, phone number, email id, status" 
                        value={searchQuery} 
                        onChange={handleSearch} 
                    />
                    <Link to="/super/add-shop" className="btn btn-success" >Add new shop</Link>
                </div>
                {fetchLoading ? 
                    <Spinner color="danger" spinnerSize="lg" /> :
                    filteredShops?.length > 0 ? 
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Name</th>
                                    <th>Phone Number</th>
                                    <th>Email ID</th>
                                    <th>Address</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredShops?.map((shop, index) => (
                                    <ShopRow shop={shop} key={nanoid()} getShops={getShops} index={index + 1} />
                                ))}
                            </tbody>
                        </table> : <Error mainText="No shop found!" secondaryText={<Link to="/super/add-shop">Add New shop</Link>} />}
            </div>
        </div>
    </SuperAdminHeader>
}

const ShopRow = ({ shop, getShops, index }) => {
    const toast = useNotification();

    const handleDeleteSettings = async () => {
        if (shop.id) {
            try {
                const response = await api.delete('/shop/?id=' + shop.id, superAdminReqConfig());
                if (response.status === 200) {
                    toast({ type: SUCCESS, message: response.data.message });
                    getShops();
                }
            } catch (error) {
                toast({ type: ERROR, message: error.response?.data?.message || error.message });
            }
        }
    };

    return (
        <tr className="align-middle">
            <td>{index}</td>
            <td>{shop.name}</td>
            <td>{shop.phoneNumber}</td>
            <td>{shop.emailId}</td>
            <td>{shop.area}<br />{shop.address}<br />{shop.pin}</td>
            <td>
                <i className={`fas fa-circle blink ${shop.status === 'active' ? 'text-success' : 'text-danger'}`} style={{ fontSize: '1.3rem', margin:'10px' }} />
                <span className="ps-2">{shop.status}</span>
            </td>
            <td>
                <Link to={`/super/edit-shop/${shop.id}`} className="m-3 btn btn-sm btn-primary">Edit</Link>
                {shop.status === "inactive" && (
                    <button className="btn btn-sm btn-danger ms-2" onClick={handleDeleteSettings}>Delete</button>
                )}
            </td>
                        <td></td>
        </tr>
    )
}

export default SuperAdminShop